<div class="flex-c gap-32 padding-bottom-48 align-center">
  @if (isLoading) {
    <div class="loading-wrapper">
      <mat-progress-spinner
        color="primary"
        mode="indeterminate"
        diameter="32"></mat-progress-spinner>
    </div>
  } @else {
    <div class="page-navigation">
      <div class="circle-large" (click)="onGoBack()">
        <div class="circle-icon">
          <i class="fa-regular fa-arrow-left fa-xl"></i>
        </div>
      </div>
    </div>
    <form [formGroup]="invoiceForm" class="container background-transparent">
      <div class="display-flex align-center gap-8 align-self-stretch title">
        <div class="w-h-44 flex-c align-center justify-center">
          <i class="fa-regular fa-receipt fa-2x"></i>
        </div>
        <span class="font-medium-title-large"> Rechnungsanschrift </span>
        <div class="flex-1-0-0"></div>
      </div>
      <span class="font-regular-body-large font-color-black">
        Diese Informationen sind wichtig, um die Rechnung zu erstellen und dich
        im Falle von Rückfragen bezüglich der Kursanmeldung zu kontaktieren.
      </span>
      <div class="formular-row-2-inputs">
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="facility">
            Einrichtung{{
              fieldRequired(invoiceForm.get('facility')) ? '*' : ''
            }}
          </div>
          <input
            id="facility"
            class="input-field"
            formControlName="facility"
            name="facility"
            type="text"
            placeholder="Einrichtung" />
          <app-error-message
            [formField]="invoiceForm.get('facility')"></app-error-message>
        </div>
        <div class="flex-1-0-0 placeholder"></div>
      </div>
      <div class="formular-row-2-inputs">
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="firstName">
            Vorname{{ fieldRequired(invoiceForm.get('firstName')) ? '*' : '' }}
          </div>
          <input
            id="firstName"
            class="input-field"
            formControlName="firstName"
            name="firstName"
            type="text"
            autocomplete="given-name"
            placeholder="Vorname" />
          <app-error-message
            [formField]="invoiceForm.get('firstName')"></app-error-message>
        </div>
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="lastName">
            Nachname{{ fieldRequired(invoiceForm.get('lastName')) ? '*' : '' }}
          </div>
          <input
            id="lastName"
            class="input-field"
            formControlName="lastName"
            name="lastName"
            type="text"
            autocomplete="family-name"
            placeholder="Nachname" />
          <app-error-message
            [formField]="invoiceForm.get('lastName')"></app-error-message>
        </div>
      </div>
      <div class="formular-row-2-inputs">
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="street">
            Straße{{ fieldRequired(invoiceForm.get('street')) ? '*' : '' }}
          </div>
          <input
            id="street"
            class="input-field"
            formControlName="street"
            name="street"
            type="text"
            autocomplete="street-address"
            placeholder="Straße" />
          <app-error-message
            [formField]="invoiceForm.get('street')"></app-error-message>
        </div>
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="houseNumber">
            Hausnummer{{
              fieldRequired(invoiceForm.get('houseNumber')) ? '*' : ''
            }}
          </div>
          <input
            id="houseNumber"
            class="input-field"
            formControlName="houseNumber"
            name="houseNumber"
            type="text"
            placeholder="Hausnummer" />
          <app-error-message
            [formField]="invoiceForm.get('houseNumber')"></app-error-message>
        </div>
      </div>
      <div class="formular-row-2-inputs">
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="zip">
            PLZ{{ fieldRequired(invoiceForm.get('zipCode')) ? '*' : '' }}
          </div>
          <input
            id="zip"
            class="input-field"
            formControlName="zipCode"
            name="zip"
            type="text"
            autocomplete="postal-code"
            placeholder="PLZ" />
          <app-error-message
            [formField]="invoiceForm.get('zipCode')"></app-error-message>
        </div>
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="city">
            Ort{{ fieldRequired(invoiceForm.get('city')) ? '*' : '' }}
          </div>
          <input
            id="city"
            class="input-field"
            formControlName="city"
            name="city"
            type="text"
            autocomplete="address-level1"
            placeholder="Ort" />
          <app-error-message
            [formField]="invoiceForm.get('city')"></app-error-message>
        </div>
      </div>
      <div class="formular-row-2-inputs">
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="country">
            Land{{ fieldRequired(invoiceForm.get('country')) ? '*' : '' }}
          </div>
          <p-select
            id="country"
            formControlName="country"
            [options]="countryOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Land auswählen..." />
          <app-error-message
            [formField]="invoiceForm.get('country')"></app-error-message>
        </div>
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="email">
            E-Mail{{ fieldRequired(invoiceForm.get('email')) ? '*' : '' }}
          </div>
          <input
            id="email"
            class="input-field"
            formControlName="email"
            name="email"
            type="text"
            autocomplete="email"
            placeholder="E-Mail" />
          <app-error-message
            [formField]="invoiceForm.get('email')"></app-error-message>
        </div>
      </div>
      <div class="formular-row-2-inputs">
        <div class="input-simple flex-1-0-0">
          <div class="input-label" for="phone">
            Telefon{{ fieldRequired(invoiceForm.get('phone')) ? '*' : '' }}
          </div>
          <input
            id="phone"
            class="input-field"
            formControlName="phone"
            name="phone"
            type="text"
            autocomplete="tel"
            placeholder="Telefon" />
          <app-error-message
            [formField]="invoiceForm.get('phone')"></app-error-message>
        </div>
        <div class="flex-1-0-0 placeholder"></div>
      </div>
      <div>
        <span
          class="font-regular-body-large"
          style="color: var(--neutral-10, #807b78)">
          * Pflichtfelder sind mit einem Sternchen gekennzeichnet.
        </span>
      </div>
    </form>
  }

  @if (invoiceForm.valid) {
    <div>
      Jetzt
      {{
        cartService.getItemsCount() == 1
          ? 'Gutschein'
          : cartService.getItemsCount() + ' Gutscheine'
      }}
      für
      <span class="total-amount">{{
        cartService.getTotalAmount() | currency: 'EUR'
      }}</span>
      kaufen.
    </div>
    <div class="paypal-button" id="paypal-button-container"></div>
  }
</div>
